/* Packrift sample selection. Server owns eligibility, quantity and final price. */
(() => {
  'use strict';
  if (window.PackriftSamplesLoaded) return;
  window.PackriftSamplesLoaded = true;
  const MAX = 4, FIRST = 700, EXTRA = 400;
  const KEY = 'packrift.samples.v1', REQUEST_KEY = 'packrift.sample-checkout.v1';
  const ENDPOINT = 'https://187-77-24-204.sslip.io/packrift/quote-intake/sample-checkout';
  const configNode = document.querySelector('[data-pks-product]');
  const card = document.querySelector('[data-pks-card]');
  if (!configNode || !card) return;
  let product;
  try { product = JSON.parse(configNode.textContent); } catch (_) { return; }
  const money = cents => new Intl.NumberFormat('en-US', {style:'currency',currency:'USD'}).format(cents / 100);
  const text = (tag, content, cls) => { const el = document.createElement(tag); el.textContent = content; if (cls) el.className = cls; return el; };
  let samples = [];
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || '[]');
    if (Array.isArray(saved)) samples = saved.filter(x => x && /^\d{8,20}$/.test(x.id) && typeof x.sku === 'string' && typeof x.title === 'string' && typeof x.url === 'string' && x.url.startsWith('/products/')).slice(0, MAX);
    samples = samples.filter((x,i,a) => a.findIndex(y => y.sku === x.sku) === i);
  } catch (_) {}
  const add = card.querySelector('[data-pks-add]'), view = card.querySelector('[data-pks-view]'), status = card.querySelector('[data-pks-status]');
  let dialog, list, slots, total, shipping, count, submit, error, empty, totals, busy = false;
  function currentVariant() {
    const scope = card.closest('.shopify-section') || document;
    const selector = scope.querySelector('select[name="id"],#prx-variant-select,#ph-variant-select');
    const hidden = scope.querySelector('form[action*="/cart/add"] [name="id"]');
    const id = String((selector && selector.value) || (hidden && hidden.value) || product.selected);
    return product.variants.find(v => String(v.id) === id);
  }
  function save() {
    try { localStorage.setItem(KEY, JSON.stringify(samples)); sessionStorage.removeItem(REQUEST_KEY); } catch (_) {}
    refresh();
  }
  function refresh() {
    const variant = currentVariant();
    card.hidden = !variant || !variant.available || !variant.sku;
    const inBasket = variant && samples.some(x => x.sku === variant.sku);
    add.textContent = inBasket ? 'Sample added ✓' : 'Add sample';
    view.hidden = samples.length === 0;
    view.textContent = 'View samples (' + samples.length + ')';
  }
  function render() {
    list.replaceChildren();
    samples.forEach(sample => {
      const li = text('li', '', 'pks-item');
      if (typeof sample.image === 'string' && /^(https:)?\/\/(cdn\.shopify\.com|packrift\.com)\//.test(sample.image)) {
        const img = document.createElement('img'); img.className = 'pks-item__image'; img.src = sample.image; img.alt = ''; img.width = 56; img.height = 56; li.append(img);
      }
      const info = text('div', '', 'pks-item__info');
      const title = text('a', sample.title, 'pks-item__title'); title.href = sample.url;
      info.append(title, text('p', '1 sample · SKU ' + sample.sku, 'pks-item__meta'));
      const remove = text('button', 'Remove', 'pks-remove'); remove.type = 'button'; remove.setAttribute('aria-label','Remove sample of ' + sample.title); remove.disabled = busy;
      remove.addEventListener('click', () => { samples = samples.filter(x => x.id !== sample.id); save(); render(); });
      li.append(info, remove); list.append(li);
    });
    const n = samples.length, cents = n ? FIRST + EXTRA * (n - 1) : 0;
    count.textContent = 'Samples (' + n + ')'; shipping.textContent = money(cents); total.textContent = money(cents);
    slots.textContent = n === MAX ? 'All 4 sample spots are filled.' : 'Choose up to ' + (MAX - n) + ' more different product' + (MAX - n === 1 ? '' : 's') + '. Each additional sample adds $4 shipping.';
    submit.disabled = busy || n === 0; submit.hidden = n === 0; totals.hidden = n === 0; slots.hidden = n === 0; empty.hidden = n > 0;
    submit.textContent = busy ? 'Opening secure checkout…' : 'Sample checkout · ' + money(cents);
  }
  function makeDialog() {
    if (dialog) return;
    dialog = document.createElement('dialog'); dialog.className = 'pks-dialog'; dialog.setAttribute('aria-labelledby','pks-dialog-title');
    const body = text('div','','pks-dialog__body'), head = text('div','','pks-dialog__head'), h = text('h2','Your samples'); h.id = 'pks-dialog-title';
    const close = text('button','×','pks-close'); close.type='button'; close.setAttribute('aria-label','Close samples'); close.addEventListener('click',()=>{if(!busy)dialog.close();}); head.append(h,close);
    list = text('ul','','pks-list'); slots = text('p','','pks-slots'); empty=text('p','No samples selected yet. Choose a product you’d like to try.','pks-dialog__empty');
    totals=text('dl','','pks-totals');
    const r1=text('div',''),r2=text('div',''),r3=text('div','','pks-totals__total');count=text('dt','');shipping=text('dd','');total=text('dd','');
    r1.append(count,text('dd','FREE','pks-free'));r2.append(text('dt','Shipping & handling'),shipping);r3.append(text('dt','Total before tax'),total);totals.append(r1,r2,r3);
    error=text('p','','pks-dialog__error');error.setAttribute('role','alert');
    submit=text('button','','pks-button pks-button--primary');submit.type='button';submit.addEventListener('click',checkout);
    const keep=text('button','Keep browsing','pks-button pks-button--secondary');keep.type='button';keep.addEventListener('click',()=>{if(!busy)dialog.close();});
    const selection=text('div','','pks-dialog__selection'), footer=text('div','','pks-dialog__footer');
    selection.append(list,empty,slots);
    footer.append(totals,error,submit,keep,text('p','Contiguous U.S. only. Samples are ordered separately from full packs. Any applicable tax is shown at checkout.','pks-dialog__terms'));
    body.append(head,text('p','One sample of each product, so you can choose with confidence.','pks-dialog__sub'),selection,footer);
    dialog.append(body);document.body.append(dialog);
    dialog.addEventListener('click',e=>{if(e.target===dialog&&!busy){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
    dialog.addEventListener('cancel',e=>{if(busy)e.preventDefault();});
  }
  function open() { makeDialog(); error.textContent=''; render(); if(!dialog.open)dialog.showModal(); }
  function requestId(ids) {
    const signature=ids.slice().sort().join(',');
    try { const old=JSON.parse(sessionStorage.getItem(REQUEST_KEY)||'null');if(old&&old.signature===signature&&Date.now()-old.time<30*60*1000)return old.id; }catch(_){}
    const id=crypto.randomUUID();try{sessionStorage.setItem(REQUEST_KEY,JSON.stringify({signature,id,time:Date.now()}));}catch(_){}return id;
  }
  async function checkout() {
    if(busy||samples.length<1||samples.length>MAX)return;
    const ids=samples.map(x=>x.id);busy=true;error.textContent='';render();
    const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),65000);
    try {
      const response=await fetch(ENDPOINT,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({variant_ids:ids,request_id:requestId(ids)}),credentials:'omit',signal:controller.signal});
      const data=await response.json();
      if(!response.ok||!data.ok||!data.checkout_url){
        if(['service_unavailable','sample_unavailable','duplicate_sample','checkout_rejected'].includes(data.error)){
          try{sessionStorage.removeItem(REQUEST_KEY);}catch(_){}
        }
        throw new Error(data.message||'We couldn’t open sample checkout. Please try again or contact support@packrift.com.');
      }
      const url=new URL(data.checkout_url);
      if(url.protocol!=='https:'||!['packrift.com','packrift.myshopify.com'].includes(url.hostname))throw new Error('Checkout could not be verified. Please contact support@packrift.com.');
      window.location.assign(url.href);
    }catch(e){error.textContent=e.name==='AbortError'?'Checkout is taking longer than expected. Try once more to reopen the same request.':String(e.message).slice(0,300);busy=false;render();}
    finally{clearTimeout(timeout);}
  }
  add.addEventListener('click',()=>{
    const variant=currentVariant();if(!variant||!variant.available||!variant.sku)return;
    if(samples.some(x=>x.sku===variant.sku)){open();return;}
    if(samples.length>=MAX){open();error.textContent='You can choose up to 4 different samples. Remove one to add this product.';return;}
    samples.push({id:String(variant.id),sku:variant.sku,title:product.title+(variant.title!=='Default Title'?' ('+variant.title+')':''),url:product.url+'?variant='+variant.id,image:product.image});save();open();
  });
  view.addEventListener('click',open);
  document.addEventListener('change',()=>setTimeout(refresh,0));
  window.addEventListener('pageshow',()=>{busy=false;refresh();if(dialog&&dialog.open)render();});
  refresh();
})();
